import type { RequirementClassification } from '../api/requirements';

export type InboxTab = 'open' | 'clarification' | 'released';

export type ClassFilter = 'all' | RequirementClassification;

type TabDef = {
  readonly id: InboxTab;
  readonly label: string;
};

const TABS: readonly TabDef[] = [
  { id: 'open', label: 'Alle offen' },
  { id: 'clarification', label: 'Rückfragen' },
  { id: 'released', label: 'Freigegeben' },
];

type Props = {
  readonly tab: InboxTab;
  readonly tabCounts: Readonly<Record<InboxTab, number>>;
  readonly onTabChange: (t: InboxTab) => void;
  readonly classFilter: ClassFilter;
  readonly onClassFilterChange: (c: ClassFilter) => void;
  readonly customerFilter: string;
  readonly customers: readonly string[];
  readonly onCustomerFilterChange: (c: string) => void;
};

export function FilterBar({
  tab,
  tabCounts,
  onTabChange,
  classFilter,
  onClassFilterChange,
  customerFilter,
  customers,
  onCustomerFilterChange,
}: Props) {
  return (
    <div className="filterbar">
      <div className="filterbar-inner">
        <div className="tabs" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={tab === t.id}
              className={'tab ' + (tab === t.id ? 'active' : '')}
              onClick={() => onTabChange(t.id)}
            >
              {t.label}
              <span className="tab-count">{tabCounts[t.id]}</span>
            </button>
          ))}
        </div>
        <div className="filter-sep" />
        <button
          type="button"
          className={'filter-chip ' + (classFilter === 'BUG' ? 'on' : '')}
          onClick={() => onClassFilterChange(classFilter === 'BUG' ? 'all' : 'BUG')}
        >
          <span className="bar bug" />
          Bug
        </button>
        <button
          type="button"
          className={'filter-chip ' + (classFilter === 'USER_STORY' ? 'on' : '')}
          onClick={() =>
            onClassFilterChange(classFilter === 'USER_STORY' ? 'all' : 'USER_STORY')
          }
        >
          <span className="bar story" />
          User Story
        </button>
        <select
          className="filter-chip"
          value={customerFilter}
          onChange={(e) => onCustomerFilterChange(e.target.value)}
          aria-label="Kunde filtern"
        >
          <option value="all">Alle Kunden</option>
          {customers.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
